export enum DateValidationEnum {
  CURRENT_DATE = 'current',
}
